import React from 'react';
import Loading from './Global/Loading';
import {COPY_STRINGS} from '../constants/translatedCopy';
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions.js";
import { getLanguageForLocale } from '../services/locale';

function VoicePickerOption ({ title, image, locale, onClick, isButtonDisabled }) {
  const className = "optionButton" + (isButtonDisabled ? " disabled" : "");
  const style = image ? {} : {justifyContent: 'center', textAlign: 'center'}
  
  return (
    <div className={className} {...doNotUseAccessibleStaticElementInteractions({onClick: onClick})} style={style}>
      {image && <img src={image} alt={title} />}
      <span className="option-title" lang={getLanguageForLocale(locale)}>{title}</span>
    </div>
  );
}
export default class VoicePicker extends React.Component {
  constructor (props){
    super(props);
    this.voiceSelect= this.voiceSelect.bind(this);
    this.state = {
      selectedOption: {},
    };
  }

  componentDidMount(){
    this.initOptions();
  }

  componentDidUpdate(prevProps){
    //Only do ths if the options have changed
    if(prevProps.options != this.props.options){
      this.initOptions();
    }
  }

  //We check for this in both the componentDidMount and componentDidUpdate because
  // sometime the prop has propagated by the time the component mounts and sometimes it
  // doesnt. Keep it for now until we can come up with a better solution.
  initOptions(){
    let options = this.props.options;
    let names = [];
    for(let i = 0; i < options.length; i++){
      let option = options[i];
      names.push(option.name);
    }
    if(this.props.speech && names.length > 0){
      this.props.speech.requestMatch(names, 0.6, this.voiceSelect);
    }
  }

  voiceSelect(matchIndex){
    let options = this.props.options;
    if(matchIndex >= 0){
      let chosenOption = options[matchIndex];
      this.selectOption(chosenOption);
      this.props.speech.resetTranscript(); //Need to clear spoken story from transcript before proceeding
    } else {

      //clean up to try to avoid loop
      this.props.speech.stopListening();
      this.props.speech.resetTranscript();


      let props = {};

      props.onEnd= (
        function(event){
          this.props.speech.resetTranscript();
        }
      ).bind(this);

      props.textToSpeak = this.props.prompt;
      props.skipAvatar = false;
    }
  }

  // returns a function to select a given story
  selectOption(option){
    if(!this.props.buttonsDisabled){
      if(this.props.speech){
        this.props.speech.cancelMatchRequest();
        this.props.speech.stopListening();
      }
      this.setState({selectedOption: option});
      this.props.selectOption(option);
    }
  }

  getButtons(){
    return (
      <div className="options-wrapper">
        {this.props.options.map((option, i) =>
          <VoicePickerOption
            key={"option" + i}
            title={option.name}
            image={option.image}
            locale={option.locale}
            isButtonDisabled={this.props.buttonsDisabled}
            onClick={() => this.selectOption(option)}
          />
        )}
      </div>
    );
  }

  render() {
    if(this.props.loading){
      return(
        <div className="loadingModal">
          <div className="loadingText __subtitle">{COPY_STRINGS.loading + " " + this.state.selectedOption.name}...</div>
          <div className="loadingWrapper"><Loading noFill={true}/></div>
        </div>
      );
    }
    const highlightedText = this.props.highlightedText ? (<span className="highlighted-text __subtitle">{this.props.highlightedText}</span>) : null;
    return (
      <div className="voicePicker">
        <div className="voiceHeader">
          <span className="voicePicker-title __title">{this.props.title}</span>
          {highlightedText}
          <span className="sub-title __body-text">{this.props.subTitle}</span>
        </div>
        {this.getButtons()}
      </div>
    );
  }
}
